export default [ // '///' 段落分割线
  [{
      q: "為什麽搜尋不到車輛？",
      a: "1.請檢查車輛是否處於啟動狀態，並處於P檔；///\
    2.請檢查手機藍牙功能是否處於已開啟狀態，或嘗試重啟手機藍牙功能。（由於Android10系統BUG，Android10系統版本用戶需要開啟定位功能）///\
    3.請檢查車輛是否正處於待綁定狀態。<br/>\
    為保證您的車輛安全，車輛進入待啟用狀態後，若2分鐘內無任何操作、被推行或駕駛，車輛將自動退出待啟用狀態，或導致無法搜索到車輛；<br/>\
    您可通過再次啟動車輛，在特定時間內通過APP搜索完成啟用操作。"
    },
    {
      q: "點擊連接搜尋到的車輛，但是提示連接失敗？",
      a: "1.請檢查車輛是否正處於待綁定狀態。<br/>\
    為保證您的車輛安全，車輛進入待啟用狀態後，若2分鐘內無任何操作、被推行或駕駛，車輛將自動退出待啟用狀態，或導致無法搜索到車輛。<br/>\
    您可通過再次啟動車輛，在特定時間內通過APP搜索完成啟用操作。///\
    2.可能是由於您手機藍牙的信號不穩定。造成連接困難。您可以嘗試重新搜尋後再次嘗試連接車輛。"
    },
    {
      q: "一直顯示“車輛網路啟用中…”，該怎麽辦？",
      a: "1.請檢查您的車輛網路是否正常。<br/>\
    您可通過車輛螢幕查看網絡狀態，若發現車輛網路狀態不好，建議您將車輛移至開闊的室外環境或網路良好的環境下。///\
    2.請檢查您的手機網路是否正常。<br/>\
    可能由於您的手機網路異常或不穩定，導致啟用狀態未能及時同步。///\
    3.檢查您THEMO APP的“通知權限”是否開啟。您可嘗試前往手機設置中心→通知→THEMO APP→打開通知權限；（用於手機系統版本差異，操作流程可能存在差異）///\
    4.您可嘗試在THEMO APP內退出賬號並重新登錄來解決這個問題。"
    },
    {
      q: "啟用綁定後，就完成了與車輛的藍牙連接嗎？",
      a: "啟用綁定後，手機與車輛僅完成了BLE（低功耗藍牙）模組的連接，用於手機與車輛的基本通讯。"
    },
    {
      q: "如何解除綁定車輛？",
      a: "登錄THEMO APP，從APP側邊欄選擇要解綁的車輛，點擊刪除車輛，勾選刪除協議後點擊刪除即可成功解除綁定。"
    },
    {
      q: "APP解綁車輛後，車輛無法進入待啟用狀態？",
      a: "APP解綁後，車輛無法重新進入待啟用狀態，可能是因為當前車輛網路不佳導致的：///\
      1.您可將車輛停放在環境開闊，網路較好的位置，並重啟車輛查看狀態；///\
      2.檢查車輛服務方案是否到期，若服務方案已到期，請續費後，重啟車輛進行查看。"
    }
  ],
  [{
      q: "如何更換/解綁手機號？",
      a: "為保證您的帳戶安全，啟用車輛後務必需要綁定手機門號，因此啟用車輛的帳號不支援直接解綁，僅支持更換成其他手機門號。///\
      如需更換，您可使用APP點擊設置，進入帳號安全中心，對帳號綁定進行管理，點擊手機號進行變更即可。"
    },
    {
      q: "一個帳號可以多個設備使用嗎？",
      a: "THEMO帳號登錄是不限制手機設備的，但是為了保護帳號安全及車輛安全，不支援一個帳號同時在多個手機設備上使用，否則可能會被自動退出。"
    },
    {
      q: "如何註銷帳號？",
      a: "THEMO APP支援帳號註銷，但您需要确保該帳號下已無綁定車輛，且無未完成或未支付的服務。///\
      您可點擊設定→帳號安全→帳戶註銷，進行帳號的註銷。///\
      註銷帳號是不可恢復的操作，請您謹慎操作。註銷成功後，您將無法登陸或使用THEMO帳號内的所有訊息。"
    },
    {
      q: "如何管理車輛的數據權限？",
      a: "THEMO非常重視您的隱私保護和個人資訊的保護。///\
      您可以利用THEMO電動實現但不限於查看車況，定位車輛，定位您所在的位置、車輛動態紀錄，以及遙控車輛，設置車輛等功能。///\
      在秉着“最小化”原則的前提下，我们將直接或間接獲取您的車輛的定位及行駛軌跡資訊，並做加密處理。<br/>\
      您可以通過進入車輛管理介面，選擇“車輛數據與權限”功能進行權限的管理。相應功能停用後，可能導致部分功能無法正常使用。"
    }
  ],
  [{
      q: "騎行之前，需要做哪些準備？",
      a: "為保證您的騎行安全，請在騎行前做如下準備：///\
      1.檢查車輛能否正常通電，燈光照明等狀態是否正常；<br/>\
      2.檢查前、後煞車能否正常⼯作；<br/>\
      3.檢查輪胎的氣壓是否正常；<br/>\
      4.檢查車把及前後輪是否固定，龍頭鎖是否已解鎖；<br/>\
      5.保證電池電量充⾜；<br/>\
      6.是否存在其他故障提示；<br/>\
      7.佩戴好頭盔及其他符合要求的護具。"
    },
    {
      q: "如何啟動車輛？",
      a: "請通過以下二種任⼀⽅式啟動車輛：<br/>///\
      1.遙控鑰匙：(1) 點擊遙控器上的開鎖按鈕；(2) 靠近⻋輛後長按車輛螢幕下⽅電源按鍵；<br/>\
      2.⼿機：(1) 打開⼿機 App 點擊“Start”；(2) 車輛綁定⼿機，靠近車輛待螢幕上藍⽛標誌亮起，點按螢幕下⽅按鍵啟動；"
    },
    {
      q: "結束騎行後，需要做哪些事情？",
      a: "到達目的地後，點按“P”鍵取消騎行模式，並放下側撐或中撐。///\
      您可通過以下任一種任壹方式為車輛上鎖：<br/>\
      1.遙控器：點擊遙控器上的上鎖按鈕；<br/>\
      2.⼿機：打開⼿機 App，點擊“設防”為車輛上鎖；///\
      車輛上鎖後，請將車輛龍頭轉至左轉向並檢查龍頭鎖是否鎖定。"
    }
  ],
  [{
      q: "關於車輛定位的問題",
      a: "車輛是通過衛星的GPS信號獲得定位。車輛在室內或地庫等封閉區域時，將影響車輛定位的準確性。將車輛移至開闊的壞境，GPS定位功能將恢復。///\
      車輛軌跡是車輛在規定時間內上報的定位點一次連線形成的車輛軌跡。由於定位偏移以及信號遮擋，會造成捕捉到錯誤的定位甚至丟失定位點的情況，導致軌跡異常或不準確的情況。///\
      若長時間不能定位或大部分軌跡異常，請檢查車輛智能服務是否到期，若未到期，可聯繫售後檢查車輛的網路及GPS的情況。"
    },
    {
      q: "關於消息推送的問題",
      a: "您可以通過以下操作進行排查：///\
      1.請您確認首頁右上角消息中心列表裏是否可以收到相應的推送消息，如車輛震動；<br/>\
      2.管理手機的通知設置：您可前往手機設置中心，選擇通知功能，選擇THEMO APP，確認相應的功能已經開啟。<br/>\
      3.THEMO APP內選擇車輛，選擇車輛防盜模式，查看相應的通知推送是否開啟。"
    },
    {
      q: "什麽是車輛的防盜模式？",
      a: "為保證您的車輛安全，針對車輛的異常動向進行了消息推送提醒，包括車輛的震動、輪動、電池斷開、電池過放等。///\
      您可以根據車輛的停放風險，選擇警戒模式或勿擾模式，進行防盜的個性化設置。///\
      當車輛發生異動，可通過查看車輛定位，查看車輛當前位置，確保車輛的安全。"
    },
    {
      q: "預計行駛里程計算不準確的問題",
      a: "車輛的預計行駛裏程，是根據用戶的駕駛習慣於耗電量的情況綜合統計而來的。影響預估裏程準確性有多種原因，例如載物的情況、道路情況以及環境溫度等，通常偏差值在20%之間屬於正常現象。///\
      如果有明顯偏大或偏小的情況，通常不是電池出了問題，而是在數據統計端由於數據穩定性或數據錯誤導致的。若騎行數次後仍存在偏差大的問題，可聯系售後進行問題的排查。"
    },
    {
      q: "車輛遠程控制沒有反應怎麽辦？",
      a: "請您查看當前手機網絡是否正常，並查看THEMO app首頁右上角藍牙和網絡是否連接正常。若網絡或藍牙狀態任意壹個連接正常的情況下均可下發遠程控制指令。"
    }
  ],
  [{
      q: "車輛升級有什麽用?",
      a: "車輛OTA升級主要用於改善用車體驗，優化車輛功能，每次車輛OTA升級，會提示車輛升級的功能組件，每次升級的內容請以升級當時的頁面為準。"
    },
    {
      q: "車輛升級需要具備哪些條件？",
      a: "1.確保車輛已啟動，並處於駐車狀態。並保證車內的電池總電量大於20%，升級期間切勿不要移除電池。///\
      2.確保手機的藍牙功能及無線網絡功能處於開啟狀態，並靠近車輛，保持手機與車輛處於連接狀態。"
    },
    {
      q: "車輛升級期間需要注意哪些事項？",
      a: "1.車輛升級期間，請不要駕駛車輛，並確保車輛處於開啟且非騎行狀態；///\
      2.車輛升級期間，請勿遠離車輛，並保持車輛與手機一直處於連接狀態；///\
      3.車輛升級開始後，請勿移除車輛電池；///\
      4.車輛升級開始後，請勿關閉螢幕，並保持手機無線網路及藍牙功能處於開啟狀態。"
    },
    {
      q: "升級結束了，但是不知道是否成功怎麽辦？",
      a: "車輛升級期間，請不要遠離車輛，並保持藍牙處於連接狀態。///\
      在升級過程通過藍牙通訊，告知手機端當前車輛的升級狀態。因此，在車輛升級過程中，切勿遠離車輛或關掉APP。///\
      若因特殊情況，斷開了連接，可嘗試重新連接車輛。或刷新系統升級頁面，查看當前車輛版本，若均顯示“已是最新版本”則升級成功，若部分升級組件仍不是最新版本，請重新升級。"
    }
  ],
  [{
      q: "電池使用期間有哪些注意事項？",
      a: "1.電池使用環境：<br/>\
      請在 -10~45℃ 環境下使⽤；<br/>\
      避免被液體浸濕；<br/>\
      避免⾦屬異物進⼊電池倉；<br/>\
      避免讓電池靠近明⽕、易燃易爆氣體等危險場所。///\
      2.電池容量衰減：<br/>\
      在低溫情況下，電池可⽤容量會有不同程度的衰減，參考值為：<br/>\
      -10 ℃ 可⽤容量約為 70%；<br/>\
      0 ℃ 可⽤容量約為 85%；<br/>\
      25 ℃ 可⽤容量約為 100%；///\
      3.電池安全注意事項：<br/>\
      如電池出現異常，如發熱、變形或產⽣異味，請⽴即停⽤並遠離電池，<br/>\
      聯繫售後部門進行檢修，不可私⾃拆解電池。如擅⾃拆解電池，有可能會發⽣起⽕、爆炸等安全事故，同時⾃動失去保固資格。"
    },
    {
      q: "如何延長電池的使用壽命？",
      a: "電池的壽命主要是由電池充電循環次數和使用存儲環境決定的，充電循環是指當電量為100%，電池完整放電一次再重新充滿記做一次充電循環。良好的使用習慣，隨用隨充，50%電量存放，溫度在0℃~25℃之間的乾燥環境存放，避免過放可以有效的延長電池的使用壽命。"
    }
  ],
]



// WEBPACK FOOTER //
// ./src/assets/js/solo/tw/questions.js